import React from 'react';
import { Logo, LogoMain } from '../logo';

export const LiviaLogo = () => (
  <Logo url="https://galaxy.blob.core.windows.net/web/livia_logo.png" text="" />
);

export const BigLiviaLogo = () => (
  <LogoMain url="https://galaxy.blob.core.windows.net/web/livia_logo.png" />
);
